export const environment = {
  production: true,
  buildId: '3482034391322271',
  configFile: 'config.json',
};
